import { ref } from 'vue';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
  message: string;
  type?: ToastType;
  duration?: number;
}

const show = ref(false);
const message = ref('');
const type = ref<ToastType>('info');
const duration = ref(3000);

export function useToast() {
  function showToast(options: ToastOptions | string) {
    if (typeof options === 'string') {
      message.value = options;
      type.value = 'info';
      duration.value = 3000;
    } else {
      message.value = options.message;
      type.value = options.type || 'info';
      duration.value = options.duration || 3000;
    }
    show.value = true;
  }

  function success(msg: string, dur = 3000) {
    showToast({ message: msg, type: 'success', duration: dur });
  }

  function error(msg: string, dur = 3000) {
    showToast({ message: msg, type: 'error', duration: dur });
  }

  function warning(msg: string, dur = 3000) {
    showToast({ message: msg, type: 'warning', duration: dur });
  }

  function info(msg: string, dur = 3000) {
    showToast({ message: msg, type: 'info', duration: dur });
  }

  return {
    show,
    message,
    type,
    duration,
    showToast,
    success,
    error,
    warning,
    info,
  };
}
